/**
 * useBrandToken — read one served brand token by name (ADR-063).
 *
 * For the rare widget dial whose value drives a PRESENTATION VARIANT
 * (not CSS) — e.g. `--team-visual`, `--topscorers-style`. Config-driven
 * per brand, never a branch on tenant identity (rule 3): the value is
 * data from `runtimeConfig.brand.tokens`, identical in every bundle.
 * Returns null outside a live/paused tenant context (Storybook, tests)
 * so callers fall back to the platform-default variant.
 */
import { useTenantConfig } from './useTenantConfig.js';

export function useBrandToken(name: string): string | null {
  const tenant = useTenantConfig();
  if (tenant.kind !== 'live' && tenant.kind !== 'paused') return null;
  return tenant.config.brand.tokens[name] ?? null;
}
